import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

type Errors = {
  defaultMessage: string;
  id: string;
  field?: string;
  type: string;
  values: Record<string, unknown> | null;
  variables?: {
    errorMessage?: string;
    errorType?: string;
    status?: string;
    uri?: string;
    'River API Error'?: string;
  };
};

type Messages = {
  defaultMessage: string;
  id: string;
  field: string;
  variables: Record<string, unknown> | null;
};

export type ApiResponse<T> = {
  errors: Errors[] | null;
  messages: Messages[];
  response: T;
};

export type ApiError = FetchBaseQueryError & {
  data: {
    errors: Errors[] | null;
    messages: Messages[];
    response: null;
  };
};

export type ApiResultHandlers<T> = {
  onSuccess?: (response: ApiResponse<T>) => unknown;
  onError?: (response: ApiError) => unknown;
};

export enum EMI {
  Wallester = 'WALLESTER'
}

export enum FileFormat {
  PDF = 'pdf',
  CSV = 'csv'
}

export type MessageHandlers = {
  showError?: (message: string) => unknown;
  showSuccess?: (message: string) => unknown;
};

export type IntlFormatMessageFunc = ({ id }: { id: string }) => string;
